import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import {
  EXPENSE_STATUS_BADGE,
  ExpenseStatusBadge,
} from '../../constants/expense-status-badge.map';
import { ExpenseStatus, isExpenseStatus } from '../../enums/expense-status.enum';

/**
 * Etiqueta de estado.
 *
 * No usa `<tui-badge>` a propósito: Taiga le añade un punto de color a la
 * izquierda que el diseño no tiene, y pelearse con sus internals a base de
 * `::ng-deep` sale peor que un pill propio de doce líneas de CSS.
 */
@Component({
  selector: 'app-expense-status-badge',
  templateUrl: './expense-status-badge.component.html',
  styleUrls: ['./expense-status-badge.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ExpenseStatusBadgeComponent {
  /** `null` en los gastos históricos: no se pinta etiqueta. */
  @Input() status: ExpenseStatus | null = null;

  protected get badge(): ExpenseStatusBadge | null {
    return isExpenseStatus(this.status)
      ? EXPENSE_STATUS_BADGE[this.status]
      : null;
  }
}
